import { createFileRoute } from '@tanstack/react-router'
import { ConsultantsPage } from '@/pages/ConsultantsPage'
import { fetchConsultants } from '@/services/api/consultantsClient.ts'
import { ROUTES } from '@/constants/routeConstants.ts'

export const Route = createFileRoute(`${ROUTES.CONSULTANTS_LIST}/`)({
  loader: async () => {
    try {
      const consultants = await fetchConsultants()
      return { consultants, error: null }
    } catch (error) {
      return {
        consultants: { total: 0, next: null, previous: null, items: [] },
        error,
      }
    }
  },
  component: ConsultantsPage,
})
